// Copyright (c) 2016 Deere & Company

import claimsInProgressActions from './claims-in-progress/actions-list';
import dealerInvoicesActions from './dealer-invoices/actions-list';
import incentiveClaimActions from './incentive/action-list';
import jdpActions from './marketing/jdp/action-list';
import laborRateChangeActions from './labor-rate-change/actions-list';
import laborRateDealersActions from './labor-rate-dealers/actions-list';
import maintenancePlanActions from './marketing/maintenance-plan/action-list';
import massChannelCustomerFollowupActions from './marketing/mass-channel-customer-followup/action-list';
import massChannelPdiActions from './marketing/mass-channel-pdi/action-list';
import massLaborRatesActions from './mass-labor-rate-change/actions-list';
import massLaborRatesRequestStatusActions from './mass-labor-rate-request-status-details/actions-list';
import sharedActions from '../shared/actions-list';
import spaActions from './spa/action-list';
import wearPartsClaimActions from './wear-parts/action-list';

export default Object.freeze({
    ...claimsInProgressActions,
    ...dealerInvoicesActions,
    ...incentiveClaimActions,
    ...jdpActions,
    ...laborRateChangeActions,
    ...laborRateDealersActions,
    ...maintenancePlanActions,
    ...massChannelCustomerFollowupActions,
    ...massChannelPdiActions,
    ...massLaborRatesActions,
    ...massLaborRatesRequestStatusActions,
    ...spaActions,
    ...sharedActions,
    ...wearPartsClaimActions,
    ADD_CLAIM_ATTACHMENT_ADDITIONAL_REPAIR: 'ADD_CLAIM_ATTACHMENT_ADDITIONAL_REPAIR',
    ADD_CLAIM_ATTACHMENT_FILE: 'ADD_CLAIM_ATTACHMENT_FILE',
    ADD_CLAIM_BATTERY_ADDITIONAL_REPAIR: 'ADD_CLAIM_BATTERY_ADDITIONAL_REPAIR',
    ADD_CLAIM_BATTERY_FILE: 'ADD_CLAIM_BATTERY_FILE',
    ADD_CLAIM_NORMAL_ADDITIONAL_REPAIR: 'ADD_CLAIM_NORMAL_ADDITIONAL_REPAIR',
    ADD_CLAIM_NORMAL_FILE: 'ADD_CLAIM_NORMAL_FILE',
    ADD_CLAIM_PARTS_ADDITIONAL_REPAIR: 'ADD_CLAIM_PARTS_ADDITIONAL_REPAIR',
    ADD_CLAIM_PARTS_FILE: 'ADD_CLAIM_PARTS_FILE',
    ADD_CLAIM_PIP_ADDITIONAL_REPAIR: 'ADD_CLAIM_PIP_ADDITIONAL_REPAIR',
    ADD_CLAIM_PIP_FILE: 'ADD_CLAIM_PIP_FILE',
    ADD_CLAIM_TRACK_ADDITIONAL_REPAIR: 'ADD_CLAIM_TRACK_ADDITIONAL_REPAIR',
    ADD_CLAIM_TRACK_FILE: 'ADD_CLAIM_TRACK_FILE',
    COPY_CLAIM_ATTACHMENT: 'COPY_CLAIM_ATTACHMENT',
    COPY_CLAIM_BATTERY: 'COPY_CLAIM_BATTERY',
    COPY_CLAIM_NORMAL: 'COPY_CLAIM_NORMAL',
    COPY_CLAIM_PARTS: 'COPY_CLAIM_PARTS',
    COPY_CLAIM_PIP: 'COPY_CLAIM_PIP',
    COPY_CLAIM_TRACK: 'COPY_CLAIM_TRACK',
    CREATE_CLAIM_ATTACHMENT_LABOR: 'CREATE_CLAIM_ATTACHMENT_LABOR',
    CREATE_CLAIM_ATTACHMENT_OTHER_CREDIT: 'CREATE_CLAIM_ATTACHMENT_OTHER_CREDIT',
    CREATE_CLAIM_ATTACHMENT_PART: 'CREATE_CLAIM_ATTACHMENT_PART',
    CREATE_CLAIM_BATTERY_LABOR: 'CREATE_CLAIM_BATTERY_LABOR',
    CREATE_CLAIM_BATTERY_OTHER_CREDIT: 'CREATE_CLAIM_BATTERY_OTHER_CREDIT',
    CREATE_CLAIM_BATTERY_PART: 'CREATE_CLAIM_BATTERY_PART',
    CREATE_CLAIM_NORMAL_LABOR: 'CREATE_CLAIM_NORMAL_LABOR',
    CREATE_CLAIM_NORMAL_OTHER_CREDIT: 'CREATE_CLAIM_NORMAL_OTHER_CREDIT',
    CREATE_CLAIM_NORMAL_PART: 'CREATE_CLAIM_NORMAL_PART',
    CREATE_CLAIM_PARTS_LABOR: 'CREATE_CLAIM_PARTS_LABOR',
    CREATE_CLAIM_PARTS_OTHER_CREDIT: 'CREATE_CLAIM_PARTS_OTHER_CREDIT',
    CREATE_CLAIM_PARTS_PART: 'CREATE_CLAIM_PARTS_PART',
    CREATE_CLAIM_PIP_LABOR: 'CREATE_CLAIM_PIP_LABOR',
    CREATE_CLAIM_PIP_OTHER_CREDIT: 'CREATE_CLAIM_PIP_OTHER_CREDIT',
    CREATE_CLAIM_PIP_PART: 'CREATE_CLAIM_PIP_PART',
    CREATE_CLAIM_TRACK_LABOR: 'CREATE_CLAIM_TRACK_LABOR',
    CREATE_CLAIM_TRACK_OTHER_CREDIT: 'CREATE_CLAIM_TRACK_OTHER_CREDIT',
    CREATE_CLAIM_TRACK_PART: 'CREATE_CLAIM_TRACK_PART',
    DELETE_CLAIM_ATTACHMENT_FILE: 'DELETE_CLAIM_ATTACHMENT_FILE',
    DELETE_CLAIM_ATTACHMENT_LABOR: 'DELETE_CLAIM_ATTACHMENT_LABOR',
    DELETE_CLAIM_ATTACHMENT_OTHER_CREDIT: 'DELETE_CLAIM_ATTACHMENT_OTHER_CREDIT',
    DELETE_CLAIM_ATTACHMENT_PART: 'DELETE_CLAIM_ATTACHMENT_PART',
    DELETE_CLAIM_BATTERY_FILE: 'DELETE_CLAIM_BATTERY_FILE',
    DELETE_CLAIM_BATTERY_LABOR: 'DELETE_CLAIM_BATTERY_LABOR',
    DELETE_CLAIM_BATTERY_OTHER_CREDIT: 'DELETE_CLAIM_BATTERY_OTHER_CREDIT',
    DELETE_CLAIM_BATTERY_PART: 'DELETE_CLAIM_BATTERY_PART',
    DELETE_CLAIM_NORMAL_FILE: 'DELETE_CLAIM_NORMAL_FILE',
    DELETE_CLAIM_NORMAL_LABOR: 'DELETE_CLAIM_NORMAL_LABOR',
    DELETE_CLAIM_NORMAL_OTHER_CREDIT: 'DELETE_CLAIM_NORMAL_OTHER_CREDIT',
    DELETE_CLAIM_NORMAL_PART: 'DELETE_CLAIM_NORMAL_PART',
    DELETE_CLAIM_PARTS_FILE: 'DELETE_CLAIM_PARTS_FILE',
    DELETE_CLAIM_PARTS_LABOR: 'DELETE_CLAIM_PARTS_LABOR',
    DELETE_CLAIM_PARTS_OTHER_CREDIT: 'DELETE_CLAIM_PARTS_OTHER_CREDIT',
    DELETE_CLAIM_PARTS_PART: 'DELETE_CLAIM_PARTS_PART',
    DELETE_CLAIM_PIP_FILE: 'DELETE_CLAIM_PIP_FILE',
    DELETE_CLAIM_PIP_LABOR: 'DELETE_CLAIM_PIP_LABOR',
    DELETE_CLAIM_PIP_OTHER_CREDIT: 'DELETE_CLAIM_PIP_OTHER_CREDIT',
    DELETE_CLAIM_PIP_PART: 'DELETE_CLAIM_PIP_PART',
    DELETE_CLAIM_TRACK_FILE: 'DELETE_CLAIM_TRACK_FILE',
    DELETE_CLAIM_TRACK_LABOR: 'DELETE_CLAIM_TRACK_LABOR',
    DELETE_CLAIM_TRACK_OTHER_CREDIT: 'DELETE_CLAIM_TRACK_OTHER_CREDIT',
    DELETE_CLAIM_TRACK_PART: 'DELETE_CLAIM_TRACK_PART',
    FILTER_CLAIM_SEARCH_RESULTS: 'FILTER_CLAIM_SEARCH_RESULTS',
    OPEN_ALL_CLAIMS_ACCORDION: 'OPEN_ALL_CLAIMS_ACCORDION',
    READ_CLAIM_SEARCH_CLAIM_TYPES_SUCCESS: 'READ_CLAIM_SEARCH_CLAIM_TYPES_SUCCESS',
    RESET_ALL_CLAIMS_FILTERS: 'RESET_ALL_CLAIMS_FILTERS',
    RESET_CLAIM_ATTACHMENT: 'RESET_CLAIM_ATTACHMENT',
    RESET_CLAIM_ATTACHMENT_CONFIRMATION_MODAL: 'RESET_CLAIM_ATTACHMENT_CONFIRMATION_MODAL',
    RESET_CLAIM_ATTACHMENT_FORM_VALIDATION: 'RESET_CLAIM_ATTACHMENT_FORM_VALIDATION',
    RESET_CLAIM_BATTERY: 'RESET_CLAIM_BATTERY',
    RESET_CLAIM_BATTERY_CONFIRMATION_MODAL: 'RESET_CLAIM_BATTERY_CONFIRMATION_MODAL',
    RESET_CLAIM_BATTERY_FORM_VALIDATION: 'RESET_CLAIM_BATTERY_FORM_VALIDATION',
    RESET_CLAIM_BATTERY_PIN_DETAILS: 'RESET_CLAIM_BATTERY_PIN_DETAILS',
    RESET_CLAIM_BATTERY_PRODUCT_DETAILS: 'RESET_CLAIM_BATTERY_PRODUCT_DETAILS',
    RESET_CLAIM_BATTERY_USE_AMOUNTS: 'RESET_CLAIM_BATTERY_USE_AMOUNTS',
    RESET_CLAIM_NORMAL: 'RESET_CLAIM_NORMAL',
    RESET_CLAIM_NORMAL_CONFIRMATION_MODAL: 'RESET_CLAIM_NORMAL_CONFIRMATION_MODAL',
    RESET_CLAIM_NORMAL_CREATE_PIN_MODAL_PIN: 'RESET_CLAIM_NORMAL_CREATE_PIN_MODAL_PIN',
    RESET_CLAIM_NORMAL_FORM_VALIDATION: 'RESET_CLAIM_NORMAL_FORM_VALIDATION',
    RESET_CLAIM_NORMAL_PRODUCT_DETAILS: 'RESET_CLAIM_NORMAL_PRODUCT_DETAILS',
    RESET_CLAIM_NORMAL_USE_AMOUNTS: 'RESET_CLAIM_NORMAL_USE_AMOUNTS',
    RESET_CLAIM_PARTS: 'RESET_CLAIM_PARTS',
    RESET_CLAIM_PARTS_CONFIRMATION_MODAL: 'RESET_CLAIM_PARTS_CONFIRMATION_MODAL',
    RESET_CLAIM_PARTS_FORM_VALIDATION: 'RESET_CLAIM_PARTS_FORM_VALIDATION',
    RESET_CLAIM_PARTS_PRODUCT_DETAILS: 'RESET_CLAIM_PARTS_PRODUCT_DETAILS',
    RESET_CLAIM_PARTS_USE_AMOUNTS: 'RESET_CLAIM_PARTS_USE_AMOUNTS',
    RESET_CLAIM_PIP: 'RESET_CLAIM_PIP',
    RESET_CLAIM_PIP_CONFIRMATION_MODAL: 'RESET_CLAIM_PIP_CONFIRMATION_MODAL',
    RESET_CLAIM_PIP_FORM_VALIDATION: 'RESET_CLAIM_PIP_FORM_VALIDATION',
    RESET_CLAIM_PIP_PIP_DETAILS: 'RESET_CLAIM_PIP_PIP_DETAILS',
    RESET_CLAIM_PIP_PIP_PRODUCTS: 'RESET_CLAIM_PIP_PIP_PRODUCTS',
    RESET_CLAIM_PIP_PRODUCT_DETAILS: 'RESET_CLAIM_PIP_PRODUCT_DETAILS',
    RESET_CLAIM_PIP_USE_AMOUNTS: 'RESET_CLAIM_PIP_USE_AMOUNTS',
    RESET_CLAIM_SEARCH_FILTERS: 'RESET_CLAIM_SEARCH_FILTERS',
    RESET_CLAIM_TRACK: 'RESET_CLAIM_TRACK',
    RESET_CLAIM_TRACK_CONFIRMATION_MODAL: 'RESET_CLAIM_TRACK_CONFIRMATION_MODAL',
    RESET_CLAIM_TRACK_FORM_VALIDATION: 'RESET_CLAIM_TRACK_FORM_VALIDATION',
    RESET_CLAIM_TRACK_PIN_DETAILS: 'RESET_CLAIM_TRACK_PIN_DETAILS',
    RESET_CLAIM_TRACK_PRODUCT_DETAILS: 'RESET_CLAIM_TRACK_PRODUCT_DETAILS',
    RESET_CLAIM_TRACK_REPLACEMENT_DETAILS: 'RESET_CLAIM_TRACK_REPLACEMENT_DETAILS',
    RESET_CLAIM_TRACK_USE_AMOUNTS: 'RESET_CLAIM_TRACK_USE_AMOUNTS',
    REVISE_CLAIM_ATTACHMENT: 'REVISE_CLAIM_ATTACHMENT',
    REVISE_CLAIM_BATTERY: 'REVISE_CLAIM_BATTERY',
    REVISE_CLAIM_NORMAL: 'REVISE_CLAIM_NORMAL',
    REVISE_CLAIM_PARTS: 'REVISE_CLAIM_PARTS',
    REVISE_CLAIM_PIP: 'REVISE_CLAIM_PIP',
    REVISE_CLAIM_TRACK: 'REVISE_CLAIM_TRACK',
    SELECT_ALL_CLAIMS_CLAIM_STATUS_FACET_ITEMS: 'SELECT_ALL_CLAIMS_CLAIM_STATUS_FACET_ITEMS',
    SELECT_ALL_CLAIMS_DEALER_ACCOUNT_FACET_ITEMS: 'SELECT_ALL_CLAIMS_DEALER_ACCOUNT_FACET_ITEMS',
    SELECT_ALL_CLAIM_SEARCH_CLAIM_STATUS_FACET_ITEMS: 'SELECT_ALL_CLAIM_SEARCH_CLAIM_STATUS_FACET_ITEMS',
    SELECT_ALL_CLAIM_SEARCH_DEALER_ACCOUNT_FACET_ITEMS: 'SELECT_ALL_CLAIM_SEARCH_DEALER_ACCOUNT_FACET_ITEMS',
    SET_CLAIM_ATTACHMENT: 'SET_CLAIM_ATTACHMENT',
    SET_CLAIM_ATTACHMENT_CONFIRMATION_MODAL: 'SET_CLAIM_ATTACHMENT_CONFIRMATION_MODAL',
    SET_CLAIM_ATTACHMENT_PART_DETAILS: 'SET_CLAIM_ATTACHMENT_PART_DETAILS',
    SET_CLAIM_ATTACHMENT_PRODUCT_DETAILS: 'SET_CLAIM_ATTACHMENT_PRODUCT_DETAILS',
    SET_CLAIM_BATTERY: 'SET_CLAIM_BATTERY',
    SET_CLAIM_BATTERY_CONFIRMATION_MODAL: 'SET_CLAIM_BATTERY_CONFIRMATION_MODAL',
    SET_CLAIM_BATTERY_CUSTOMER_DETAILS: 'SET_CLAIM_BATTERY_CUSTOMER_DETAILS',
    SET_CLAIM_BATTERY_PART_DETAILS: 'SET_CLAIM_BATTERY_PART_DETAILS',
    SET_CLAIM_BATTERY_PRODUCT_DETAILS: 'SET_CLAIM_BATTERY_PRODUCT_DETAILS',
    SET_CLAIM_NORMAL: 'SET_CLAIM_NORMAL',
    SET_CLAIM_NORMAL_CONFIRMATION_MODAL: 'SET_CLAIM_NORMAL_CONFIRMATION_MODAL',
    SET_CLAIM_NORMAL_CUSTOMER_DETAILS: 'SET_CLAIM_NORMAL_CUSTOMER_DETAILS',
    SET_CLAIM_NORMAL_PART_DETAILS: 'SET_CLAIM_NORMAL_PART_DETAILS',
    SET_CLAIM_NORMAL_PRODUCT_DETAILS: 'SET_CLAIM_NORMAL_PRODUCT_DETAILS',
    SET_CLAIM_PARTS: 'SET_CLAIM_PARTS',
    SET_CLAIM_PARTS_CONFIRMATION_MODAL: 'SET_CLAIM_PARTS_CONFIRMATION_MODAL',
    SET_CLAIM_PARTS_CUSTOMER_DETAILS: 'SET_CLAIM_PARTS_CUSTOMER_DETAILS',
    SET_CLAIM_PARTS_PART_DETAILS: 'SET_CLAIM_PARTS_PART_DETAILS',
    SET_CLAIM_PARTS_PRODUCT_DETAILS: 'SET_CLAIM_PARTS_PRODUCT_DETAILS',
    SET_CLAIM_PIP: 'SET_CLAIM_PIP',
    SET_CLAIM_PIP_CONFIRMATION_MODAL: 'SET_CLAIM_PIP_CONFIRMATION_MODAL',
    SET_CLAIM_PIP_CUSTOMER_DETAILS: 'SET_CLAIM_PIP_CUSTOMER_DETAILS',
    SET_CLAIM_PIP_PART_DETAILS: 'SET_CLAIM_PIP_PART_DETAILS',
    SET_CLAIM_PIP_PRODUCT_DETAILS: 'SET_CLAIM_PIP_PRODUCT_DETAILS',
    SET_CLAIM_TRACK: 'SET_CLAIM_TRACK',
    SET_CLAIM_TRACK_CONFIRMATION_MODAL: 'SET_CLAIM_TRACK_CONFIRMATION_MODAL',
    SET_CLAIM_TRACK_CUSTOMER_DETAILS: 'SET_CLAIM_TRACK_CUSTOMER_DETAILS',
    SET_CLAIM_TRACK_PART_DETAILS: 'SET_CLAIM_TRACK_PART_DETAILS',
    SET_CLAIM_TRACK_PRODUCT_DETAILS: 'SET_CLAIM_TRACK_PRODUCT_DETAILS',
    TOGGLE_ACCORDION: 'TOGGLE_ACCORDION',
    TOGGLE_ALL_CLAIMS_CLAIM_STATUS_FACET_ITEMS: 'TOGGLE_ALL_CLAIMS_CLAIM_STATUS_FACET_ITEMS',
    TOGGLE_ALL_CLAIMS_DEALER_ACCOUNT_FACET_ITEMS: 'TOGGLE_ALL_CLAIMS_DEALER_ACCOUNT_FACET_ITEMS',
    TOGGLE_CLAIMS_REPORTS_ACCORDION: 'TOGGLE_CLAIMS_REPORTS_ACCORDION',
    TOGGLE_CLAIM_BATTERY_WARRANTY_STATUS_MODAL: 'TOGGLE_CLAIM_BATTERY_WARRANTY_STATUS_MODAL',
    TOGGLE_CLAIM_INCENTIVE_WARRANTY_STATUS_MODAL: 'TOGGLE_CLAIM_INCENTIVE_WARRANTY_STATUS_MODAL',
    TOGGLE_CLAIM_JDP_WARRANTY_STATUS_MODAL: 'TOGGLE_CLAIM_JDP_WARRANTY_STATUS_MODAL',
    TOGGLE_CLAIM_MAINTENANCE_PLAN_WARRANTY_STATUS_MODAL: 'TOGGLE_CLAIM_MAINTENANCE_PLAN_WARRANTY_STATUS_MODAL',
    TOGGLE_CLAIM_MCC_WARRANTY_STATUS_MODAL: 'TOGGLE_CLAIM_MCC_WARRANTY_STATUS_MODAL',
    TOGGLE_CLAIM_NORMAL_WARRANTY_STATUS_MODAL: 'TOGGLE_CLAIM_NORMAL_WARRANTY_STATUS_MODAL',
    TOGGLE_CLAIM_PARTS_WARRANTY_STATUS_MODAL: 'TOGGLE_CLAIM_PARTS_WARRANTY_STATUS_MODAL',
    TOGGLE_CLAIM_PIP_WARRANTY_STATUS_MODAL: 'TOGGLE_CLAIM_PIP_WARRANTY_STATUS_MODAL',
    TOGGLE_CLAIM_SEARCH_CLAIM_STATUS_FACET_ITEMS: 'TOGGLE_CLAIM_SEARCH_CLAIM_STATUS_FACET_ITEMS',
    TOGGLE_CLAIM_SEARCH_CLAIM_TYPE_FACET_ITEMS: 'TOGGLE_CLAIM_SEARCH_CLAIM_TYPE_FACET_ITEMS',
    TOGGLE_CLAIM_SEARCH_DEALER_ACCOUNT_FACET_ITEMS: 'TOGGLE_CLAIM_SEARCH_DEALER_ACCOUNT_FACET_ITEMS',
    TOGGLE_CLAIM_SPA_WARRANTY_STATUS_MODAL: 'TOGGLE_CLAIM_SPA_WARRANTY_STATUS_MODAL',
    TOGGLE_CLAIM_TRACK_WARRANTY_STATUS_MODAL: 'TOGGLE_CLAIM_TRACK_WARRANTY_STATUS_MODAL',
    UPDATE_ALL_CLAIMS_CLAIM_STATUS_FACET_ITEM: 'UPDATE_ALL_CLAIMS_CLAIM_STATUS_FACET_ITEM',
    UPDATE_ALL_CLAIMS_CLAIM_TYPES: 'UPDATE_ALL_CLAIMS_CLAIM_TYPES',
    UPDATE_ALL_CLAIMS_CREATE_CLAIM_MODAL_VISIBILITY: 'UPDATE_ALL_CLAIMS_CREATE_CLAIM_MODAL_VISIBILITY',
    UPDATE_ALL_CLAIMS_DATE_RANGE_FACET: 'UPDATE_ALL_CLAIMS_DATE_RANGE_FACET',
    UPDATE_ALL_CLAIMS_DATE_TYPE: 'UPDATE_ALL_CLAIMS_DATE_TYPE',
    UPDATE_ALL_CLAIMS_DEALER_ACCOUNT_FACET_INPUT: 'UPDATE_ALL_CLAIMS_DEALER_ACCOUNT_FACET_INPUT',
    UPDATE_ALL_CLAIMS_DEALER_ACCOUNT_FACET_ITEM: 'UPDATE_ALL_CLAIMS_DEALER_ACCOUNT_FACET_ITEM',
    UPDATE_ALL_CLAIMS_SEARCH_FILTER_BY: 'UPDATE_ALL_CLAIMS_SEARCH_FILTER_BY',
    UPDATE_ALL_CLAIMS_SEARCH_SORT_BY: 'UPDATE_ALL_CLAIMS_SEARCH_SORT_BY',
    UPDATE_ALL_CLAIMS_SEARCH_SORT_DIRECTION: 'UPDATE_ALL_CLAIMS_SEARCH_SORT_DIRECTION',
    UPDATE_ALL_CLAIM_SEARCH_RESULTS_SUCCESS: 'UPDATE_ALL_CLAIM_SEARCH_RESULTS_SUCCESS',
    UPDATE_CLAIM_ATTACHMENT_BASIS_FOR_SETTLEMENT: 'UPDATE_CLAIM_ATTACHMENT_BASIS_FOR_SETTLEMENT',
    UPDATE_CLAIM_ATTACHMENT_CLAIM_TYPES: 'UPDATE_CLAIM_ATTACHMENT_CLAIM_TYPES',
    UPDATE_CLAIM_ATTACHMENT_COMPLAINT_CAUSE: 'UPDATE_CLAIM_ATTACHMENT_COMPLAINT_CAUSE',
    UPDATE_CLAIM_ATTACHMENT_COMPLAINT_CORRECTION: 'UPDATE_CLAIM_ATTACHMENT_COMPLAINT_CORRECTION',
    UPDATE_CLAIM_ATTACHMENT_CREATE_CLAIM_MODAL_VISIBILITY: 'UPDATE_CLAIM_ATTACHMENT_CREATE_CLAIM_MODAL_VISIBILITY',
    UPDATE_CLAIM_ATTACHMENT_DOWN_TIME: 'UPDATE_CLAIM_ATTACHMENT_DOWN_TIME',
    UPDATE_CLAIM_ATTACHMENT_DTAC_CASE: 'UPDATE_CLAIM_ATTACHMENT_DTAC_CASE',
    UPDATE_CLAIM_ATTACHMENT_DTAC_SOLUTION: 'UPDATE_CLAIM_ATTACHMENT_DTAC_SOLUTION',
    UPDATE_CLAIM_ATTACHMENT_FAILED_AREA: 'UPDATE_CLAIM_ATTACHMENT_FAILED_AREA',
    UPDATE_CLAIM_ATTACHMENT_FAILED_MODE: 'UPDATE_CLAIM_ATTACHMENT_FAILED_MODE',
    UPDATE_CLAIM_ATTACHMENT_FAILED_MODE_COMMENTS: 'UPDATE_CLAIM_ATTACHMENT_FAILED_MODE_COMMENTS',
    UPDATE_CLAIM_ATTACHMENT_FAILURE_DATE: 'UPDATE_CLAIM_ATTACHMENT_FAILURE_DATE',
    UPDATE_CLAIM_ATTACHMENT_FAILURE_MODE_COLLECTION: 'UPDATE_CLAIM_ATTACHMENT_FAILURE_MODE_COLLECTION',
    UPDATE_CLAIM_ATTACHMENT_FAILURE_PART: 'UPDATE_CLAIM_ATTACHMENT_FAILURE_PART',
    UPDATE_CLAIM_ATTACHMENT_FILE: 'UPDATE_CLAIM_ATTACHMENT_FILE',
    UPDATE_CLAIM_ATTACHMENT_FORM_VALIDATION: 'UPDATE_CLAIM_ATTACHMENT_FORM_VALIDATION',
    UPDATE_CLAIM_ATTACHMENT_GOODS_INSTALLATION_VAT: 'UPDATE_CLAIM_ATTACHMENT_GOODS_INSTALLATION_VAT',
    UPDATE_CLAIM_ATTACHMENT_IS_ACTION_BUTTON_DISABLED: 'UPDATE_CLAIM_ATTACHMENT_IS_ACTION_BUTTON_DISABLED',
    UPDATE_CLAIM_ATTACHMENT_IS_COPIED: 'UPDATE_CLAIM_ATTACHMENT_IS_COPIED',
    UPDATE_CLAIM_ATTACHMENT_IS_EDITABLE: 'UPDATE_CLAIM_ATTACHMENT_IS_EDITABLE',
    UPDATE_CLAIM_ATTACHMENT_IS_VALID_CLAIM: 'UPDATE_CLAIM_ATTACHMENT_IS_VALID_CLAIM',
    UPDATE_CLAIM_ATTACHMENT_LABOR_FIELDS: 'UPDATE_CLAIM_ATTACHMENT_LABOR_FIELDS',
    UPDATE_CLAIM_ATTACHMENT_LABOR_LOCATION: 'UPDATE_CLAIM_ATTACHMENT_LABOR_LOCATION',
    UPDATE_CLAIM_ATTACHMENT_LABOR_TYPE: 'UPDATE_CLAIM_ATTACHMENT_LABOR_TYPE',
    UPDATE_CLAIM_ATTACHMENT_MODAL_MODE: 'UPDATE_CLAIM_ATTACHMENT_MODAL_MODE',
    UPDATE_CLAIM_ATTACHMENT_OPERATORS_COMMENTS: 'UPDATE_CLAIM_ATTACHMENT_OPERATORS_COMMENTS',
    UPDATE_CLAIM_ATTACHMENT_OPERATORS_COMPLAINT: 'UPDATE_CLAIM_ATTACHMENT_OPERATORS_COMPLAINT',
    UPDATE_CLAIM_ATTACHMENT_OTHER_CREDIT_AMOUNT: 'UPDATE_CLAIM_ATTACHMENT_OTHER_CREDIT_AMOUNT',
    UPDATE_CLAIM_ATTACHMENT_OTHER_CREDIT_COMMENTS: 'UPDATE_CLAIM_ATTACHMENT_OTHER_CREDIT_COMMENTS',
    UPDATE_CLAIM_ATTACHMENT_OTHER_CREDIT_DESCRIPTION: 'UPDATE_CLAIM_ATTACHMENT_OTHER_CREDIT_DESCRIPTION',
    UPDATE_CLAIM_ATTACHMENT_OTHER_CREDIT_DISTANCE: 'UPDATE_CLAIM_ATTACHMENT_OTHER_CREDIT_DISTANCE',
    UPDATE_CLAIM_ATTACHMENT_OWNERSHIP_STATUS: 'UPDATE_CLAIM_ATTACHMENT_OWNERSHIP_STATUS',
    UPDATE_CLAIM_ATTACHMENT_PART_FIELDS: 'UPDATE_CLAIM_ATTACHMENT_PART_FIELDS',
    UPDATE_CLAIM_ATTACHMENT_PART_UNIT: 'UPDATE_CLAIM_ATTACHMENT_PART_UNIT',
    UPDATE_CLAIM_ATTACHMENT_PROPERTY: 'UPDATE_CLAIM_ATTACHMENT_PROPERTY',
    UPDATE_CLAIM_ATTACHMENT_REPAIR_DATE: 'UPDATE_CLAIM_ATTACHMENT_REPAIR_DATE',
    UPDATE_CLAIM_ATTACHMENT_REPAIR_NUMBER: 'UPDATE_CLAIM_ATTACHMENT_REPAIR_NUMBER',
    UPDATE_CLAIM_ATTACHMENT_RESPONSIBLE_ACCOUNTS: 'UPDATE_CLAIM_ATTACHMENT_RESPONSIBLE_ACCOUNTS',
    UPDATE_CLAIM_ATTACHMENT_STICKY_HEADER_VISIBILITY: 'UPDATE_CLAIM_ATTACHMENT_STICKY_HEADER_VISIBILITY',
    UPDATE_CLAIM_ATTACHMENT_TEMPORARY_OBJECT_KEY: 'UPDATE_CLAIM_ATTACHMENT_TEMPORARY_OBJECT_KEY',
    UPDATE_CLAIM_ATTACHMENT_WORK_ORDER_ONE: 'UPDATE_CLAIM_ATTACHMENT_WORK_ORDER_ONE',
    UPDATE_CLAIM_ATTACHMENT_WORK_ORDER_TWO: 'UPDATE_CLAIM_ATTACHMENT_WORK_ORDER_TWO',
    UPDATE_CLAIM_BATTERY_APPLICATION: 'UPDATE_CLAIM_BATTERY_APPLICATION',
    UPDATE_CLAIM_BATTERY_APPLICATION_COLLECTION: 'UPDATE_CLAIM_BATTERY_APPLICATION_COLLECTION',
    UPDATE_CLAIM_BATTERY_BASIS_FOR_SETTLEMENT: 'UPDATE_CLAIM_BATTERY_BASIS_FOR_SETTLEMENT',
    UPDATE_CLAIM_BATTERY_CLAIM_TYPES: 'UPDATE_CLAIM_BATTERY_CLAIM_TYPES',
    UPDATE_CLAIM_BATTERY_COMPLAINT_CAUSE: 'UPDATE_CLAIM_BATTERY_COMPLAINT_CAUSE',
    UPDATE_CLAIM_BATTERY_COMPLAINT_CORRECTION: 'UPDATE_CLAIM_BATTERY_COMPLAINT_CORRECTION',
    UPDATE_CLAIM_BATTERY_CREATE_CLAIM_MODAL_VISIBILITY: 'UPDATE_CLAIM_BATTERY_CREATE_CLAIM_MODAL_VISIBILITY',
    UPDATE_CLAIM_BATTERY_DTAC_CASE: 'UPDATE_CLAIM_BATTERY_DTAC_CASE',
    UPDATE_CLAIM_BATTERY_DTAC_SOLUTION: 'UPDATE_CLAIM_BATTERY_DTAC_SOLUTION',
    UPDATE_CLAIM_BATTERY_FAILED_MODE: 'UPDATE_CLAIM_BATTERY_FAILED_MODE',
    UPDATE_CLAIM_BATTERY_FAILED_MODE_COMMENTS: 'UPDATE_CLAIM_BATTERY_FAILED_MODE_COMMENTS',
    UPDATE_CLAIM_BATTERY_FAILURE_DATE: 'UPDATE_CLAIM_BATTERY_FAILURE_DATE',
    UPDATE_CLAIM_BATTERY_FAILURE_MODE_COLLECTION: 'UPDATE_CLAIM_BATTERY_FAILURE_MODE_COLLECTION',
    UPDATE_CLAIM_BATTERY_FAILURE_PART: 'UPDATE_CLAIM_BATTERY_FAILURE_PART',
    UPDATE_CLAIM_BATTERY_FILE_LIST: 'UPDATE_CLAIM_BATTERY_FILE_LIST',
    UPDATE_CLAIM_BATTERY_FORM_VALIDATION: 'UPDATE_CLAIM_BATTERY_FORM_VALIDATION',
    UPDATE_CLAIM_BATTERY_GOODS_INSTALLATION_VAT: 'UPDATE_CLAIM_BATTERY_GOODS_INSTALLATION_VAT',
    UPDATE_CLAIM_BATTERY_INSTALLED_BY: 'UPDATE_CLAIM_BATTERY_INSTALLED_BY',
    UPDATE_CLAIM_BATTERY_INSTALLED_BY_COLLECTION: 'UPDATE_CLAIM_BATTERY_INSTALLED_BY_COLLECTION',
    UPDATE_CLAIM_BATTERY_IS_ACTION_BUTTON_DISABLED: 'UPDATE_CLAIM_BATTERY_IS_ACTION_BUTTON_DISABLED',
    UPDATE_CLAIM_BATTERY_IS_COPIED: 'UPDATE_CLAIM_BATTERY_IS_COPIED',
    UPDATE_CLAIM_BATTERY_IS_EDITABLE: 'UPDATE_CLAIM_BATTERY_IS_EDITABLE',
    UPDATE_CLAIM_BATTERY_IS_VALID_CLAIM: 'UPDATE_CLAIM_BATTERY_IS_VALID_CLAIM',
    UPDATE_CLAIM_BATTERY_LABOR_FIELDS: 'UPDATE_CLAIM_BATTERY_LABOR_FIELDS',
    UPDATE_CLAIM_BATTERY_LABOR_LOCATION: 'UPDATE_CLAIM_BATTERY_LABOR_LOCATION',
    UPDATE_CLAIM_BATTERY_LABOR_TYPE: 'UPDATE_CLAIM_BATTERY_LABOR_TYPE',
    UPDATE_CLAIM_BATTERY_MODAL_MODE: 'UPDATE_CLAIM_BATTERY_MODAL_MODE',
    UPDATE_CLAIM_BATTERY_OPERATORS_COMMENTS: 'UPDATE_CLAIM_BATTERY_OPERATORS_COMMENTS',
    UPDATE_CLAIM_BATTERY_OPERATORS_COMPLAINT: 'UPDATE_CLAIM_BATTERY_OPERATORS_COMPLAINT',
    UPDATE_CLAIM_BATTERY_OTHER_CREDIT_AMOUNT: 'UPDATE_CLAIM_BATTERY_OTHER_CREDIT_AMOUNT',
    UPDATE_CLAIM_BATTERY_OTHER_CREDIT_COMMENTS: 'UPDATE_CLAIM_BATTERY_OTHER_CREDIT_COMMENTS',
    UPDATE_CLAIM_BATTERY_OTHER_CREDIT_DESCRIPTION: 'UPDATE_CLAIM_BATTERY_OTHER_CREDIT_DESCRIPTION',
    UPDATE_CLAIM_BATTERY_OTHER_CREDIT_DISTANCE: 'UPDATE_CLAIM_BATTERY_OTHER_CREDIT_DISTANCE',
    UPDATE_CLAIM_BATTERY_OWNERSHIP_STATUS: 'UPDATE_CLAIM_BATTERY_OWNERSHIP_STATUS',
    UPDATE_CLAIM_BATTERY_PART_FIELDS: 'UPDATE_CLAIM_BATTERY_PART_FIELDS',
    UPDATE_CLAIM_BATTERY_PART_SERIAL_NUMBER: 'UPDATE_CLAIM_BATTERY_PART_SERIAL_NUMBER',
    UPDATE_CLAIM_BATTERY_PART_UNIT: 'UPDATE_CLAIM_BATTERY_PART_UNIT',
    UPDATE_CLAIM_BATTERY_PROPERTY: 'UPDATE_CLAIM_BATTERY_PROPERTY',
    UPDATE_CLAIM_BATTERY_REPAIR_DATE: 'UPDATE_CLAIM_BATTERY_REPAIR_DATE',
    UPDATE_CLAIM_BATTERY_REPAIR_NUMBER: 'UPDATE_CLAIM_BATTERY_REPAIR_NUMBER',
    UPDATE_CLAIM_BATTERY_RESPONSIBLE_ACCOUNTS: 'UPDATE_CLAIM_BATTERY_RESPONSIBLE_ACCOUNTS',
    UPDATE_CLAIM_BATTERY_STICKY_HEADER_VISIBILITY: 'UPDATE_CLAIM_BATTERY_STICKY_HEADER_VISIBILITY',
    UPDATE_CLAIM_BATTERY_TEMPORARY_OBJECT_KEY: 'UPDATE_CLAIM_BATTERY_TEMPORARY_OBJECT_KEY',
    UPDATE_CLAIM_BATTERY_USE_AMOUNT: 'UPDATE_CLAIM_BATTERY_USE_AMOUNT',
    UPDATE_CLAIM_BATTERY_USE_AMOUNTS: 'UPDATE_CLAIM_BATTERY_USE_AMOUNTS',
    UPDATE_CLAIM_BATTERY_USE_AMOUNT_ON_PRODUCT_LOAD: 'UPDATE_CLAIM_BATTERY_USE_AMOUNT_ON_PRODUCT_LOAD',
    UPDATE_CLAIM_BATTERY_USE_AMOUNT_UNIT: 'UPDATE_CLAIM_BATTERY_USE_AMOUNT_UNIT',
    UPDATE_CLAIM_BATTERY_WORK_ORDER_ONE: 'UPDATE_CLAIM_BATTERY_WORK_ORDER_ONE',
    UPDATE_CLAIM_BATTERY_WORK_ORDER_TWO: 'UPDATE_CLAIM_BATTERY_WORK_ORDER_TWO',
    UPDATE_CLAIM_DATE_RANGE_FACET: 'UPDATE_CLAIM_DATE_RANGE_FACET',
    UPDATE_CLAIM_DATE_TYPE: 'UPDATE_CLAIM_DATE_TYPE',
    UPDATE_CLAIM_GOODS_INSTALLATION_VAT_OPTIONS: 'UPDATE_CLAIM_GOODS_INSTALLATION_VAT_OPTIONS',
    UPDATE_CLAIM_HAS_SEARCH_RESULTS: 'UPDATE_CLAIM_HAS_SEARCH_RESULTS',
    UPDATE_CLAIM_NORMAL_APPLY_TRAVEL: 'UPDATE_CLAIM_NORMAL_APPLY_TRAVEL',
    UPDATE_CLAIM_NORMAL_BASIS_FOR_SETTLEMENT: 'UPDATE_CLAIM_NORMAL_BASIS_FOR_SETTLEMENT',
    UPDATE_CLAIM_NORMAL_CLAIM_TYPES: 'UPDATE_CLAIM_NORMAL_CLAIM_TYPES',
    UPDATE_CLAIM_NORMAL_COMPLAINT_CAUSE: 'UPDATE_CLAIM_NORMAL_COMPLAINT_CAUSE',
    UPDATE_CLAIM_NORMAL_COMPLAINT_CORRECTION: 'UPDATE_CLAIM_NORMAL_COMPLAINT_CORRECTION',
    UPDATE_CLAIM_NORMAL_CREATE_CLAIM_MODAL_VISIBILITY: 'UPDATE_CLAIM_NORMAL_CREATE_CLAIM_MODAL_VISIBILITY',
    UPDATE_CLAIM_NORMAL_CREATE_PIN_MODAL_ACCOUNT: 'UPDATE_CLAIM_NORMAL_CREATE_PIN_MODAL_ACCOUNT',
    UPDATE_CLAIM_NORMAL_CREATE_PIN_MODAL_FAILURE_DATE: 'UPDATE_CLAIM_NORMAL_CREATE_PIN_MODAL_FAILURE_DATE',
    UPDATE_CLAIM_NORMAL_CREATE_PIN_MODAL_INVOICE_DATE: 'UPDATE_CLAIM_NORMAL_CREATE_PIN_MODAL_INVOICE_DATE',
    UPDATE_CLAIM_NORMAL_CREATE_PIN_MODAL_INVOICE_NUMBER: 'UPDATE_CLAIM_NORMAL_CREATE_PIN_MODAL_INVOICE_NUMBER',
    UPDATE_CLAIM_NORMAL_CREATE_PIN_MODAL_PIN: 'UPDATE_CLAIM_NORMAL_CREATE_PIN_MODAL_PIN',
    UPDATE_CLAIM_NORMAL_CREATE_PIN_MODAL_VISIBILITY: 'UPDATE_CLAIM_NORMAL_CREATE_PIN_MODAL_VISIBILITY',
    UPDATE_CLAIM_NORMAL_DOWN_TIME: 'UPDATE_CLAIM_NORMAL_DOWN_TIME',
    UPDATE_CLAIM_NORMAL_DTAC_CASE: 'UPDATE_CLAIM_NORMAL_DTAC_CASE',
    UPDATE_CLAIM_NORMAL_DTAC_SOLUTION: 'UPDATE_CLAIM_NORMAL_DTAC_SOLUTION',
    UPDATE_CLAIM_NORMAL_FAILED_AREA: 'UPDATE_CLAIM_NORMAL_FAILED_AREA',
    UPDATE_CLAIM_NORMAL_FAILED_MODE: 'UPDATE_CLAIM_NORMAL_FAILED_MODE',
    UPDATE_CLAIM_NORMAL_FAILED_MODE_COMMENTS: 'UPDATE_CLAIM_NORMAL_FAILED_MODE_COMMENTS',
    UPDATE_CLAIM_NORMAL_FAILURE_DATE: 'UPDATE_CLAIM_NORMAL_FAILURE_DATE',
    UPDATE_CLAIM_NORMAL_FAILURE_MODE_COLLECTION: 'UPDATE_CLAIM_NORMAL_FAILURE_MODE_COLLECTION',
    UPDATE_CLAIM_NORMAL_FAILURE_PART: 'UPDATE_CLAIM_NORMAL_FAILURE_PART',
    UPDATE_CLAIM_NORMAL_FILE_LIST: 'UPDATE_CLAIM_NORMAL_FILE_LIST',
    UPDATE_CLAIM_NORMAL_FORM_VALIDATION: 'UPDATE_CLAIM_NORMAL_FORM_VALIDATION',
    UPDATE_CLAIM_NORMAL_GOODS_INSTALLATION_VAT: 'UPDATE_CLAIM_NORMAL_GOODS_INSTALLATION_VAT',
    UPDATE_CLAIM_NORMAL_IS_ACTION_BUTTON_DISABLED: 'UPDATE_CLAIM_NORMAL_IS_ACTION_BUTTON_DISABLED',
    UPDATE_CLAIM_NORMAL_IS_COPIED: 'UPDATE_CLAIM_NORMAL_IS_COPIED',
    UPDATE_CLAIM_NORMAL_IS_EDITABLE: 'UPDATE_CLAIM_NORMAL_IS_EDITABLE',
    UPDATE_CLAIM_NORMAL_IS_VALID_CLAIM: 'UPDATE_CLAIM_NORMAL_IS_VALID_CLAIM',
    UPDATE_CLAIM_NORMAL_LABOR_COMMENTS: 'UPDATE_CLAIM_NORMAL_LABOR_COMMENTS',
    UPDATE_CLAIM_NORMAL_LABOR_HOURS: 'UPDATE_CLAIM_NORMAL_LABOR_HOURS',
    UPDATE_CLAIM_NORMAL_LABOR_LOCATION: 'UPDATE_CLAIM_NORMAL_LABOR_LOCATION',
    UPDATE_CLAIM_NORMAL_LABOR_TYPE: 'UPDATE_CLAIM_NORMAL_LABOR_TYPE',
    UPDATE_CLAIM_NORMAL_MODAL_MODE: 'UPDATE_CLAIM_NORMAL_MODAL_MODE',
    UPDATE_CLAIM_NORMAL_OPERATORS_COMMENTS: 'UPDATE_CLAIM_NORMAL_OPERATORS_COMMENTS',
    UPDATE_CLAIM_NORMAL_OPERATORS_COMPLAINT: 'UPDATE_CLAIM_NORMAL_OPERATORS_COMPLAINT',
    UPDATE_CLAIM_NORMAL_OTHER_CREDIT_AMOUNT: 'UPDATE_CLAIM_NORMAL_OTHER_CREDIT_AMOUNT',
    UPDATE_CLAIM_NORMAL_OTHER_CREDIT_COMMENTS: 'UPDATE_CLAIM_NORMAL_OTHER_CREDIT_COMMENTS',
    UPDATE_CLAIM_NORMAL_OTHER_CREDIT_DESCRIPTION: 'UPDATE_CLAIM_NORMAL_OTHER_CREDIT_DESCRIPTION',
    UPDATE_CLAIM_NORMAL_OTHER_CREDIT_DISTANCE: 'UPDATE_CLAIM_NORMAL_OTHER_CREDIT_DISTANCE',
    UPDATE_CLAIM_NORMAL_OWNERSHIP_STATUS: 'UPDATE_CLAIM_NORMAL_OWNERSHIP_STATUS',
    UPDATE_CLAIM_NORMAL_PART_FIELDS: 'UPDATE_CLAIM_NORMAL_PART_FIELDS',
    UPDATE_CLAIM_NORMAL_PART_SERIAL_NUMBER: 'UPDATE_CLAIM_NORMAL_PART_SERIAL_NUMBER',
    UPDATE_CLAIM_NORMAL_PART_UNIT: 'UPDATE_CLAIM_NORMAL_PART_UNIT',
    UPDATE_CLAIM_NORMAL_PIN: 'UPDATE_CLAIM_NORMAL_PIN',
    UPDATE_CLAIM_NORMAL_REMAN_INDICATOR: 'UPDATE_CLAIM_NORMAL_REMAN_INDICATOR',
    UPDATE_CLAIM_NORMAL_REPAIR_DATE: 'UPDATE_CLAIM_NORMAL_REPAIR_DATE',
    UPDATE_CLAIM_NORMAL_REPAIR_NUMBER: 'UPDATE_CLAIM_NORMAL_REPAIR_NUMBER',
    UPDATE_CLAIM_NORMAL_RESPONSIBLE_ACCOUNTS: 'UPDATE_CLAIM_NORMAL_RESPONSIBLE_ACCOUNTS',
    UPDATE_CLAIM_NORMAL_SERIAL_NUMBER: 'UPDATE_CLAIM_NORMAL_SERIAL_NUMBER',
    UPDATE_CLAIM_NORMAL_SHOW_APPLY_TRAVEL: 'UPDATE_CLAIM_NORMAL_SHOW_APPLY_TRAVEL',
    UPDATE_CLAIM_NORMAL_STICKY_HEADER_VISIBILITY: 'UPDATE_CLAIM_NORMAL_STICKY_HEADER_VISIBILITY',
    UPDATE_CLAIM_NORMAL_TECH_ID: 'UPDATE_CLAIM_NORMAL_TECH_ID',
    UPDATE_CLAIM_NORMAL_TEMPORARY_OBJECT_KEY: 'UPDATE_CLAIM_NORMAL_TEMPORARY_OBJECT_KEY',
    UPDATE_CLAIM_NORMAL_UPDATE_SHOW_APPLY_TRAVEL: 'UPDATE_CLAIM_NORMAL_UPDATE_SHOW_APPLY_TRAVEL',
    UPDATE_CLAIM_NORMAL_USE_AMOUNT: 'UPDATE_CLAIM_NORMAL_USE_AMOUNT',
    UPDATE_CLAIM_NORMAL_USE_AMOUNTS: 'UPDATE_CLAIM_NORMAL_USE_AMOUNTS',
    UPDATE_CLAIM_NORMAL_USE_AMOUNT_ON_PRODUCT_LOAD: 'UPDATE_CLAIM_NORMAL_USE_AMOUNT_ON_PRODUCT_LOAD',
    UPDATE_CLAIM_NORMAL_USE_AMOUNT_UNIT: 'UPDATE_CLAIM_NORMAL_USE_AMOUNT_UNIT',
    UPDATE_CLAIM_NORMAL_WORK_ORDER_ONE: 'UPDATE_CLAIM_NORMAL_WORK_ORDER_ONE',
    UPDATE_CLAIM_NORMAL_WORK_ORDER_TWO: 'UPDATE_CLAIM_NORMAL_WORK_ORDER_TWO',
    UPDATE_CLAIM_PARTS_APPLICATION: 'UPDATE_CLAIM_PARTS_APPLICATION',
    UPDATE_CLAIM_PARTS_APPLICATION_COLLECTION: 'UPDATE_CLAIM_PARTS_APPLICATION_COLLECTION',
    UPDATE_CLAIM_PARTS_BASIS_FOR_SETTLEMENT: 'UPDATE_CLAIM_PARTS_BASIS_FOR_SETTLEMENT',
    UPDATE_CLAIM_PARTS_CLAIM_TYPES: 'UPDATE_CLAIM_PARTS_CLAIM_TYPES',
    UPDATE_CLAIM_PARTS_COMPLAINT_CAUSE: 'UPDATE_CLAIM_PARTS_COMPLAINT_CAUSE',
    UPDATE_CLAIM_PARTS_COMPLAINT_CORRECTION: 'UPDATE_CLAIM_PARTS_COMPLAINT_CORRECTION',
    UPDATE_CLAIM_PARTS_CREATE_CLAIM_MODAL_VISIBILITY: 'UPDATE_CLAIM_PARTS_CREATE_CLAIM_MODAL_VISIBILITY',
    UPDATE_CLAIM_PARTS_DOWN_TIME: 'UPDATE_CLAIM_PARTS_DOWN_TIME',
    UPDATE_CLAIM_PARTS_DTAC_CASE: 'UPDATE_CLAIM_PARTS_DTAC_CASE',
    UPDATE_CLAIM_PARTS_DTAC_SOLUTION: 'UPDATE_CLAIM_PARTS_DTAC_SOLUTION',
    UPDATE_CLAIM_PARTS_FAILED_AREA: 'UPDATE_CLAIM_PARTS_FAILED_AREA',
    UPDATE_CLAIM_PARTS_FAILED_MODE: 'UPDATE_CLAIM_PARTS_FAILED_MODE',
    UPDATE_CLAIM_PARTS_FAILED_MODE_COMMENTS: 'UPDATE_CLAIM_PARTS_FAILED_MODE_COMMENTS',
    UPDATE_CLAIM_PARTS_FAILURE_DATE: 'UPDATE_CLAIM_PARTS_FAILURE_DATE',
    UPDATE_CLAIM_PARTS_FAILURE_MODE_COLLECTION: 'UPDATE_CLAIM_PARTS_FAILURE_MODE_COLLECTION',
    UPDATE_CLAIM_PARTS_FAILURE_PART: 'UPDATE_CLAIM_PARTS_FAILURE_PART',
    UPDATE_CLAIM_PARTS_FILE: 'UPDATE_CLAIM_PARTS_FILE',
    UPDATE_CLAIM_PARTS_FORM_VALIDATION: 'UPDATE_CLAIM_PARTS_FORM_VALIDATION',
    UPDATE_CLAIM_PARTS_GOODS_INSTALLATION_VAT: 'UPDATE_CLAIM_PARTS_GOODS_INSTALLATION_VAT',
    UPDATE_CLAIM_PARTS_INSTALLED_BY: 'UPDATE_CLAIM_PARTS_INSTALLED_BY',
    UPDATE_CLAIM_PARTS_INSTALLED_BY_COLLECTION: 'UPDATE_CLAIM_PARTS_INSTALLED_BY_COLLECTION',
    UPDATE_CLAIM_PARTS_IS_ACTION_BUTTON_DISABLED: 'UPDATE_CLAIM_PARTS_IS_ACTION_BUTTON_DISABLED',
    UPDATE_CLAIM_PARTS_IS_COPIED: 'UPDATE_CLAIM_PARTS_IS_COPIED',
    UPDATE_CLAIM_PARTS_IS_EDITABLE: 'UPDATE_CLAIM_PARTS_IS_EDITABLE',
    UPDATE_CLAIM_PARTS_IS_VALID_CLAIM: 'UPDATE_CLAIM_PARTS_IS_VALID_CLAIM',
    UPDATE_CLAIM_PARTS_LABOR_FIELDS: 'UPDATE_CLAIM_PARTS_LABOR_FIELDS',
    UPDATE_CLAIM_PARTS_LABOR_LOCATION: 'UPDATE_CLAIM_PARTS_LABOR_LOCATION',
    UPDATE_CLAIM_PARTS_LABOR_TYPE: 'UPDATE_CLAIM_PARTS_LABOR_TYPE',
    UPDATE_CLAIM_PARTS_MODAL_MODE: 'UPDATE_CLAIM_PARTS_MODAL_MODE',
    UPDATE_CLAIM_PARTS_OPERATORS_COMMENTS: 'UPDATE_CLAIM_PARTS_OPERATORS_COMMENTS',
    UPDATE_CLAIM_PARTS_OPERATORS_COMPLAINT: 'UPDATE_CLAIM_PARTS_OPERATORS_COMPLAINT',
    UPDATE_CLAIM_PARTS_OTHER_CREDIT_AMOUNT: 'UPDATE_CLAIM_PARTS_OTHER_CREDIT_AMOUNT',
    UPDATE_CLAIM_PARTS_OTHER_CREDIT_COMMENTS: 'UPDATE_CLAIM_PARTS_OTHER_CREDIT_COMMENTS',
    UPDATE_CLAIM_PARTS_OTHER_CREDIT_DESCRIPTION: 'UPDATE_CLAIM_PARTS_OTHER_CREDIT_DESCRIPTION',
    UPDATE_CLAIM_PARTS_OTHER_CREDIT_DISTANCE: 'UPDATE_CLAIM_PARTS_OTHER_CREDIT_DISTANCE',
    UPDATE_CLAIM_PARTS_OWNERSHIP_STATUS: 'UPDATE_CLAIM_PARTS_OWNERSHIP_STATUS',
    UPDATE_CLAIM_PARTS_PART_FIELDS: 'UPDATE_CLAIM_PARTS_PART_FIELDS',
    UPDATE_CLAIM_PARTS_PART_SERIAL_NUMBER: 'UPDATE_CLAIM_PARTS_PART_SERIAL_NUMBER',
    UPDATE_CLAIM_PARTS_PART_TYPE: 'UPDATE_CLAIM_PARTS_PART_TYPE',
    UPDATE_CLAIM_PARTS_PART_UNIT: 'UPDATE_CLAIM_PARTS_PART_UNIT',
    UPDATE_CLAIM_PARTS_PART_USE_AMOUNT: 'UPDATE_CLAIM_PARTS_PART_USE_AMOUNT',
    UPDATE_CLAIM_PARTS_PART_USE_AMOUNT_UNIT: 'UPDATE_CLAIM_PARTS_PART_USE_AMOUNT_UNIT',
    UPDATE_CLAIM_PARTS_PROPERTY: 'UPDATE_CLAIM_PARTS_PROPERTY',
    UPDATE_CLAIM_PARTS_REPAIR_DATE: 'UPDATE_CLAIM_PARTS_REPAIR_DATE',
    UPDATE_CLAIM_PARTS_REPAIR_NUMBER: 'UPDATE_CLAIM_PARTS_REPAIR_NUMBER',
    UPDATE_CLAIM_PARTS_RESPONSIBLE_ACCOUNTS: 'UPDATE_CLAIM_PARTS_RESPONSIBLE_ACCOUNTS',
    UPDATE_CLAIM_PARTS_STICKY_HEADER_VISIBILITY: 'UPDATE_CLAIM_PARTS_STICKY_HEADER_VISIBILITY',
    UPDATE_CLAIM_PARTS_TEMPORARY_OBJECT_KEY: 'UPDATE_CLAIM_PARTS_TEMPORARY_OBJECT_KEY',
    UPDATE_CLAIM_PARTS_USE_AMOUNT: 'UPDATE_CLAIM_PARTS_USE_AMOUNT',
    UPDATE_CLAIM_PARTS_USE_AMOUNTS: 'UPDATE_CLAIM_PARTS_USE_AMOUNTS',
    UPDATE_CLAIM_PARTS_USE_AMOUNT_ON_PRODUCT_LOAD: 'UPDATE_CLAIM_PARTS_USE_AMOUNT_ON_PRODUCT_LOAD',
    UPDATE_CLAIM_PARTS_USE_AMOUNT_UNIT: 'UPDATE_CLAIM_PARTS_USE_AMOUNT_UNIT',
    UPDATE_CLAIM_PARTS_WORK_ORDER_ONE: 'UPDATE_CLAIM_PARTS_WORK_ORDER_ONE',
    UPDATE_CLAIM_PARTS_WORK_ORDER_TWO: 'UPDATE_CLAIM_PARTS_WORK_ORDER_TWO',
    UPDATE_CLAIM_PART_DETAILS: 'UPDATE_CLAIM_PART_DETAILS',
    UPDATE_CLAIM_PIP_APPLICATION: 'UPDATE_CLAIM_PIP_APPLICATION',
    UPDATE_CLAIM_PIP_APPLICATION_COLLECTION: 'UPDATE_CLAIM_PIP_APPLICATION_COLLECTION',
    UPDATE_CLAIM_PIP_BASIS_FOR_SETTLEMENT: 'UPDATE_CLAIM_PIP_BASIS_FOR_SETTLEMENT',
    UPDATE_CLAIM_PIP_CLAIM_TYPES: 'UPDATE_CLAIM_PIP_CLAIM_TYPES',
    UPDATE_CLAIM_PIP_COMPLAINT_CAUSE: 'UPDATE_CLAIM_PIP_COMPLAINT_CAUSE',
    UPDATE_CLAIM_PIP_COMPLAINT_CORRECTION: 'UPDATE_CLAIM_PIP_COMPLAINT_CORRECTION',
    UPDATE_CLAIM_PIP_CREATE_CLAIM_MODAL_VISIBILITY: 'UPDATE_CLAIM_PIP_CREATE_CLAIM_MODAL_VISIBILITY',
    UPDATE_CLAIM_PIP_DOWN_TIME: 'UPDATE_CLAIM_PIP_DOWN_TIME',
    UPDATE_CLAIM_PIP_DTAC_CASE: 'UPDATE_CLAIM_PIP_DTAC_CASE',
    UPDATE_CLAIM_PIP_DTAC_SOLUTION: 'UPDATE_CLAIM_PIP_DTAC_SOLUTION',
    UPDATE_CLAIM_PIP_FAILED_AREA: 'UPDATE_CLAIM_PIP_FAILED_AREA',
    UPDATE_CLAIM_PIP_FAILED_MODE: 'UPDATE_CLAIM_PIP_FAILED_MODE',
    UPDATE_CLAIM_PIP_FAILED_MODE_COMMENTS: 'UPDATE_CLAIM_PIP_FAILED_MODE_COMMENTS',
    UPDATE_CLAIM_PIP_FAILURE_DATE: 'UPDATE_CLAIM_PIP_FAILURE_DATE',
    UPDATE_CLAIM_PIP_FAILURE_MODE_COLLECTION: 'UPDATE_CLAIM_PIP_FAILURE_MODE_COLLECTION',
    UPDATE_CLAIM_PIP_FAILURE_PART: 'UPDATE_CLAIM_PIP_FAILURE_PART',
    UPDATE_CLAIM_PIP_FILE_LIST: 'UPDATE_CLAIM_PIP_FILE_LIST',
    UPDATE_CLAIM_PIP_FORM_VALIDATION: 'UPDATE_CLAIM_PIP_FORM_VALIDATION',
    UPDATE_CLAIM_PIP_GOODS_INSTALLATION_VAT: 'UPDATE_CLAIM_PIP_GOODS_INSTALLATION_VAT',
    UPDATE_CLAIM_PIP_INSTALLED_BY: 'UPDATE_CLAIM_PIP_INSTALLED_BY',
    UPDATE_CLAIM_PIP_INSTALLED_BY_COLLECTION: 'UPDATE_CLAIM_PIP_INSTALLED_BY_COLLECTION',
    UPDATE_CLAIM_PIP_IS_ACTION_BUTTON_DISABLED: 'UPDATE_CLAIM_PIP_IS_ACTION_BUTTON_DISABLED',
    UPDATE_CLAIM_PIP_IS_COPIED: 'UPDATE_CLAIM_PIP_IS_COPIED',
    UPDATE_CLAIM_PIP_IS_EDITABLE: 'UPDATE_CLAIM_PIP_IS_EDITABLE',
    UPDATE_CLAIM_PIP_IS_NON_TRACKED: 'UPDATE_CLAIM_PIP_IS_NON_TRACKED',
    UPDATE_CLAIM_PIP_IS_VALID_CLAIM: 'UPDATE_CLAIM_PIP_IS_VALID_CLAIM',
    UPDATE_CLAIM_PIP_LABOR_FIELDS: 'UPDATE_CLAIM_PIP_LABOR_FIELDS',
    UPDATE_CLAIM_PIP_LABOR_LOCATION: 'UPDATE_CLAIM_PIP_LABOR_LOCATION',
    UPDATE_CLAIM_PIP_LABOR_TYPE: 'UPDATE_CLAIM_PIP_LABOR_TYPE',
    UPDATE_CLAIM_PIP_MODAL_MODE: 'UPDATE_CLAIM_PIP_MODAL_MODE',
    UPDATE_CLAIM_PIP_OPERATORS_COMMENTS: 'UPDATE_CLAIM_PIP_OPERATORS_COMMENTS',
    UPDATE_CLAIM_PIP_OPERATORS_COMPLAINT: 'UPDATE_CLAIM_PIP_OPERATORS_COMPLAINT',
    UPDATE_CLAIM_PIP_OTHER_CREDIT_AMOUNT: 'UPDATE_CLAIM_PIP_OTHER_CREDIT_AMOUNT',
    UPDATE_CLAIM_PIP_OTHER_CREDIT_COMMENTS: 'UPDATE_CLAIM_PIP_OTHER_CREDIT_COMMENTS',
    UPDATE_CLAIM_PIP_OTHER_CREDIT_DESCRIPTION: 'UPDATE_CLAIM_PIP_OTHER_CREDIT_DESCRIPTION',
    UPDATE_CLAIM_PIP_OTHER_CREDIT_DISTANCE: 'UPDATE_CLAIM_PIP_OTHER_CREDIT_DISTANCE',
    UPDATE_CLAIM_PIP_OWNERSHIP_STATUS: 'UPDATE_CLAIM_PIP_OWNERSHIP_STATUS',
    UPDATE_CLAIM_PIP_PART_FIELDS: 'UPDATE_CLAIM_PIP_PART_FIELDS',
    UPDATE_CLAIM_PIP_PART_SERIAL_NUMBER: 'UPDATE_CLAIM_PIP_PART_SERIAL_NUMBER',
    UPDATE_CLAIM_PIP_PART_UNIT: 'UPDATE_CLAIM_PIP_PART_UNIT',
    UPDATE_CLAIM_PIP_PIN: 'UPDATE_CLAIM_PIP_PIN',
    UPDATE_CLAIM_PIP_PIP_DETAILS: 'UPDATE_CLAIM_PIP_PIP_DETAILS',
    UPDATE_CLAIM_PIP_PIP_PRODUCTS: 'UPDATE_CLAIM_PIP_PIP_PRODUCTS',
    UPDATE_CLAIM_PIP_PIP_PROGRAM: 'UPDATE_CLAIM_PIP_PIP_PROGRAM',
    UPDATE_CLAIM_PIP_PROPERTY: 'UPDATE_CLAIM_PIP_PROPERTY',
    UPDATE_CLAIM_PIP_REPAIR_DATE: 'UPDATE_CLAIM_PIP_REPAIR_DATE',
    UPDATE_CLAIM_PIP_REPAIR_NUMBER: 'UPDATE_CLAIM_PIP_REPAIR_NUMBER',
    UPDATE_CLAIM_PIP_RESPONSIBLE_ACCOUNTS: 'UPDATE_CLAIM_PIP_RESPONSIBLE_ACCOUNTS',
    UPDATE_CLAIM_PIP_SERIAL_NUMBER: 'UPDATE_CLAIM_PIP_SERIAL_NUMBER',
    UPDATE_CLAIM_PIP_STICKY_HEADER_VISIBILITY: 'UPDATE_CLAIM_PIP_STICKY_HEADER_VISIBILITY',
    UPDATE_CLAIM_PIP_TEMPORARY_OBJECT_KEY: 'UPDATE_CLAIM_PIP_TEMPORARY_OBJECT_KEY',
    UPDATE_CLAIM_PIP_USE_AMOUNT: 'UPDATE_CLAIM_PIP_USE_AMOUNT',
    UPDATE_CLAIM_PIP_USE_AMOUNTS: 'UPDATE_CLAIM_PIP_USE_AMOUNTS',
    UPDATE_CLAIM_PIP_USE_AMOUNT_ON_PRODUCT_LOAD: 'UPDATE_CLAIM_PIP_USE_AMOUNT_ON_PRODUCT_LOAD',
    UPDATE_CLAIM_PIP_USE_AMOUNT_UNIT: 'UPDATE_CLAIM_PIP_USE_AMOUNT_UNIT',
    UPDATE_CLAIM_PIP_WORK_ORDER_ONE: 'UPDATE_CLAIM_PIP_WORK_ORDER_ONE',
    UPDATE_CLAIM_PIP_WORK_ORDER_TWO: 'UPDATE_CLAIM_PIP_WORK_ORDER_TWO',
    UPDATE_CLAIM_SEARCH_BY: 'UPDATE_CLAIM_SEARCH_BY',
    UPDATE_CLAIM_SEARCH_CLAIM_STATUS_FACET_ITEM: 'UPDATE_CLAIM_SEARCH_CLAIM_STATUS_FACET_ITEM',
    UPDATE_CLAIM_SEARCH_CLAIM_TYPES: 'UPDATE_CLAIM_SEARCH_CLAIM_TYPES',
    UPDATE_CLAIM_SEARCH_CLAIM_TYPE_FACET_ITEM: 'UPDATE_CLAIM_SEARCH_CLAIM_TYPE_FACET_ITEM',
    UPDATE_CLAIM_SEARCH_CREATE_CLAIM_MODAL_VISIBILITY: 'UPDATE_CLAIM_SEARCH_CREATE_CLAIM_MODAL_VISIBILITY',
    UPDATE_CLAIM_SEARCH_DEALER_ACCOUNT_FACET_INPUT: 'UPDATE_CLAIM_SEARCH_DEALER_ACCOUNT_FACET_INPUT',
    UPDATE_CLAIM_SEARCH_DEALER_ACCOUNT_FACET_ITEM: 'UPDATE_CLAIM_SEARCH_DEALER_ACCOUNT_FACET_ITEM',
    UPDATE_CLAIM_SEARCH_FILTER_BY: 'UPDATE_CLAIM_SEARCH_FILTER_BY',
    UPDATE_CLAIM_SEARCH_QUERY_STRING: 'UPDATE_CLAIM_SEARCH_QUERY_STRING',
    UPDATE_CLAIM_SEARCH_RESULTS_SUCCESS: 'UPDATE_CLAIM_SEARCH_RESULTS_SUCCESS',
    UPDATE_CLAIM_SEARCH_SORT_BY: 'UPDATE_CLAIM_SEARCH_SORT_BY',
    UPDATE_CLAIM_SEARCH_SORT_DIRECTION: 'UPDATE_CLAIM_SEARCH_SORT_DIRECTION',
    UPDATE_CLAIM_TRACK_APPLICATION: 'UPDATE_CLAIM_TRACK_APPLICATION',
    UPDATE_CLAIM_TRACK_APPLICATION_COLLECTION: 'UPDATE_CLAIM_TRACK_APPLICATION_COLLECTION',
    UPDATE_CLAIM_TRACK_BASIS_FOR_SETTLEMENT: 'UPDATE_CLAIM_TRACK_BASIS_FOR_SETTLEMENT',
    UPDATE_CLAIM_TRACK_CLAIM_TYPES: 'UPDATE_CLAIM_TRACK_CLAIM_TYPES',
    UPDATE_CLAIM_TRACK_COMPLAINT_CAUSE: 'UPDATE_CLAIM_TRACK_COMPLAINT_CAUSE',
    UPDATE_CLAIM_TRACK_COMPLAINT_CORRECTION: 'UPDATE_CLAIM_TRACK_COMPLAINT_CORRECTION',
    UPDATE_CLAIM_TRACK_CREATE_CLAIM_MODAL_VISIBILITY: 'UPDATE_CLAIM_TRACK_CREATE_CLAIM_MODAL_VISIBILITY',
    UPDATE_CLAIM_TRACK_DTAC_CASE: 'UPDATE_CLAIM_TRACK_DTAC_CASE',
    UPDATE_CLAIM_TRACK_DTAC_SOLUTION: 'UPDATE_CLAIM_TRACK_DTAC_SOLUTION',
    UPDATE_CLAIM_TRACK_FAILED_MODE: 'UPDATE_CLAIM_TRACK_FAILED_MODE',
    UPDATE_CLAIM_TRACK_FAILED_MODE_COMMENTS: 'UPDATE_CLAIM_TRACK_FAILED_MODE_COMMENTS',
    UPDATE_CLAIM_TRACK_FAILURE_DATE: 'UPDATE_CLAIM_TRACK_FAILURE_DATE',
    UPDATE_CLAIM_TRACK_FAILURE_MODE_COLLECTION: 'UPDATE_CLAIM_TRACK_FAILURE_MODE_COLLECTION',
    UPDATE_CLAIM_TRACK_FAILURE_PART: 'UPDATE_CLAIM_TRACK_FAILURE_PART',
    UPDATE_CLAIM_TRACK_FILE_LIST: 'UPDATE_CLAIM_TRACK_FILE_LIST',
    UPDATE_CLAIM_TRACK_FORM_VALIDATION: 'UPDATE_CLAIM_TRACK_FORM_VALIDATION',
    UPDATE_CLAIM_TRACK_GOODS_INSTALLATION_VAT: 'UPDATE_CLAIM_TRACK_GOODS_INSTALLATION_VAT',
    UPDATE_CLAIM_TRACK_INSTALLED_BY: 'UPDATE_CLAIM_TRACK_INSTALLED_BY',
    UPDATE_CLAIM_TRACK_INSTALLED_BY_COLLECTION: 'UPDATE_CLAIM_TRACK_INSTALLED_BY_COLLECTION',
    UPDATE_CLAIM_TRACK_IS_ACTION_BUTTON_DISABLED: 'UPDATE_CLAIM_TRACK_IS_ACTION_BUTTON_DISABLED',
    UPDATE_CLAIM_TRACK_IS_COPIED: 'UPDATE_CLAIM_TRACK_IS_COPIED',
    UPDATE_CLAIM_TRACK_IS_EDITABLE: 'UPDATE_CLAIM_TRACK_IS_EDITABLE',
    UPDATE_CLAIM_TRACK_IS_VALID_CLAIM: 'UPDATE_CLAIM_TRACK_IS_VALID_CLAIM',
    UPDATE_CLAIM_TRACK_LABOR_FIELDS: 'UPDATE_CLAIM_TRACK_LABOR_FIELDS',
    UPDATE_CLAIM_TRACK_LABOR_LOCATION: 'UPDATE_CLAIM_TRACK_LABOR_LOCATION',
    UPDATE_CLAIM_TRACK_LABOR_TYPE: 'UPDATE_CLAIM_TRACK_LABOR_TYPE',
    UPDATE_CLAIM_TRACK_LUGHEIGHT: 'UPDATE_CLAIM_TRACK_LUGHEIGHT',
    UPDATE_CLAIM_TRACK_LUGHEIGHT_UNIT: 'UPDATE_CLAIM_TRACK_LUGHEIGHT_UNIT',
    UPDATE_CLAIM_TRACK_LUGHEIGHT_UNIT_COLLECTION: 'UPDATE_CLAIM_TRACK_LUGHEIGHT_UNIT_COLLECTION',
    UPDATE_CLAIM_TRACK_MODAL_MODE: 'UPDATE_CLAIM_TRACK_MODAL_MODE',
    UPDATE_CLAIM_TRACK_OPERATORS_COMMENTS: 'UPDATE_CLAIM_TRACK_OPERATORS_COMMENTS',
    UPDATE_CLAIM_TRACK_OPERATORS_COMPLAINT: 'UPDATE_CLAIM_TRACK_OPERATORS_COMPLAINT',
    UPDATE_CLAIM_TRACK_OTHER_CREDIT_AMOUNT: 'UPDATE_CLAIM_TRACK_OTHER_CREDIT_AMOUNT',
    UPDATE_CLAIM_TRACK_OTHER_CREDIT_COMMENTS: 'UPDATE_CLAIM_TRACK_OTHER_CREDIT_COMMENTS',
    UPDATE_CLAIM_TRACK_OTHER_CREDIT_DESCRIPTION: 'UPDATE_CLAIM_TRACK_OTHER_CREDIT_DESCRIPTION',
    UPDATE_CLAIM_TRACK_OTHER_CREDIT_DISTANCE: 'UPDATE_CLAIM_TRACK_OTHER_CREDIT_DISTANCE',
    UPDATE_CLAIM_TRACK_OWNERSHIP_STATUS: 'UPDATE_CLAIM_TRACK_OWNERSHIP_STATUS',
    UPDATE_CLAIM_TRACK_PARTS_USE: 'UPDATE_CLAIM_TRACK_PARTS_USE',
    UPDATE_CLAIM_TRACK_PARTS_USE_UNIT: 'UPDATE_CLAIM_TRACK_PARTS_USE_UNIT',
    UPDATE_CLAIM_TRACK_PART_FIELDS: 'UPDATE_CLAIM_TRACK_PART_FIELDS',
    UPDATE_CLAIM_TRACK_PART_SERIAL_NUMBER: 'UPDATE_CLAIM_TRACK_PART_SERIAL_NUMBER',
    UPDATE_CLAIM_TRACK_PART_UNIT: 'UPDATE_CLAIM_TRACK_PART_UNIT',
    UPDATE_CLAIM_TRACK_PROPERTY: 'UPDATE_CLAIM_TRACK_PROPERTY',
    UPDATE_CLAIM_TRACK_REPAIR_DATE: 'UPDATE_CLAIM_TRACK_REPAIR_DATE',
    UPDATE_CLAIM_TRACK_REPAIR_NUMBER: 'UPDATE_CLAIM_TRACK_REPAIR_NUMBER',
    UPDATE_CLAIM_TRACK_RESPONSIBLE_ACCOUNTS: 'UPDATE_CLAIM_TRACK_RESPONSIBLE_ACCOUNTS',
    UPDATE_CLAIM_TRACK_STICKY_HEADER_VISIBILITY: 'UPDATE_CLAIM_TRACK_STICKY_HEADER_VISIBILITY',
    UPDATE_CLAIM_TRACK_TEMPORARY_OBJECT_KEY: 'UPDATE_CLAIM_TRACK_TEMPORARY_OBJECT_KEY',
    UPDATE_CLAIM_TRACK_USE_AMOUNT: 'UPDATE_CLAIM_TRACK_USE_AMOUNT',
    UPDATE_CLAIM_TRACK_USE_AMOUNTS: 'UPDATE_CLAIM_TRACK_USE_AMOUNTS',
    UPDATE_CLAIM_TRACK_USE_AMOUNT_ON_PRODUCT_LOAD: 'UPDATE_CLAIM_TRACK_USE_AMOUNT_ON_PRODUCT_LOAD',
    UPDATE_CLAIM_TRACK_USE_AMOUNT_UNIT: 'UPDATE_CLAIM_TRACK_USE_AMOUNT_UNIT',
    UPDATE_CLAIM_TRACK_WORK_ORDER_ONE: 'UPDATE_CLAIM_TRACK_WORK_ORDER_ONE',
    UPDATE_CLAIM_TRACK_WORK_ORDER_TWO: 'UPDATE_CLAIM_TRACK_WORK_ORDER_TWO',
    UPDATE_DOWN_TIME_COLLECTION: 'UPDATE_DOWN_TIME_COLLECTION',
    UPDATE_FILE_LISTS: 'UPDATE_FILE_LISTS',
    UPDATE_LABOR_LOCATIONS_COLLECTION: 'UPDATE_LABOR_LOCATIONS_COLLECTION',
    UPDATE_LABOR_TYPES_COLLECTION: 'UPDATE_LABOR_TYPES_COLLECTION',
    UPDATE_OTHER_CREDIT_TYPES_COLLECTION: 'UPDATE_OTHER_CREDIT_TYPES_COLLECTION',
    UPDATE_OWNERSHIP_STATUS_COLLECTION: 'UPDATE_OWNERSHIP_STATUS_COLLECTION',
    UPDATE_PART_USE_UNITS_COLLECTION: 'UPDATE_PART_USE_UNITS_COLLECTION'
});



// WEBPACK FOOTER //
// ./src/claim/action-list.js